function initVideoWrappers(root) {
  (root || document).querySelectorAll('[data-video-wrapper]:not([data-video-init])').forEach(function(wrapper) {
    wrapper.dataset.videoInit = '1';
    const overlay = wrapper.querySelector('[data-video-overlay]');
    const player = wrapper.querySelector('[data-video-player]');
    const videoElement = wrapper.querySelector('[data-video-element]');
    const iframe = wrapper.querySelector('[data-video-iframe]');

    if (overlay && player) {
      overlay.addEventListener('click', function() {
        overlay.style.display = 'none';
        player.style.display = 'block';

        if (videoElement) videoElement.play();
        if (iframe && iframe.dataset.src) iframe.src = iframe.dataset.src;
      });
    }
  });
}

initVideoWrappers();

document.addEventListener('shopify:section:load', function(e) {
  initVideoWrappers(e.target);
});
